import {useState} from "react";

export default function BrevetScreenNavigationItem({icon, name, isSelected, onClick}) {
    // Used in

    // PROPERTIES
    const [isHovered, setIsHovered] = useState(false)

    // BUILD
    return (
        <div className={`h-[48px] min-h-[48px] border-b-[2px] ${isSelected ? "cursor-auto border-b-greenStar" : "cursor-pointer border-b-transparent"} flex items-center space-x-[8px] px-[12px]`}
             onMouseEnter={() => setIsHovered(true)}
             onMouseLeave={() => setIsHovered(false)}
             onClick={onClick}>
            <i className={`-mr-[2px] -ml-[2px] material-icons text-[16px] ${renderIconStyle()}`}>
                {icon}
            </i>
            <span className={`font-bold text-[14px] ${isSelected || isHovered ? "text-white" : "text-greyLight7"}`}>
                {name}
            </span>
        </div>
    );

    // METHODS
    //
    function renderIconStyle() {
        return isSelected
            ? 'text-greenStar'
            : isHovered ? 'text-white' : 'text-greyLight7'
    }
}